import { Component } from '@angular/core';

@Component({
  selector: 'app-events-general',
  templateUrl: './events-general.component.html',
  styleUrls: ['./events-general.component.scss']
})
export class EventsGeneralComponent {

}
